export const formatDateForDisplay = (isoDate) => {
  if (!isoDate) return isoDate;
  
  if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(isoDate)) return isoDate;
  
  const match = isoDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (match) {
    const [, year, month, day] = match;
    return `${parseInt(day)}/${parseInt(month)}/${year}`;
  }
  
  return isoDate;
};

export const parseDateFromDisplay = (displayValue) => {
  if (!displayValue) return displayValue;

  if (/^\d{4}-\d{2}-\d{2}$/.test(displayValue)) return displayValue;

  const match = displayValue.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (match) {
    const [, day, month, year] = match;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  return displayValue;
};